// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
 
export const environment = {
  production: true,
//  MASTER_URL: "http://103.11.152.158:4071",
//  REGISTRATION_URL: "http://103.11.152.158:4075/",
//  GRIEVANCE_URL: "http://103.11.152.158:4076/secure/grievance"

  MASTER_URL: "https://democsmcmaster.probitysoftware.in",
  REGISTRATION_URL: "https://democsmcregistration.probitysoftware.in/",
  GRIEVANCE_URL: "http://103.11.152.158:4076/secure/grievance"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
